<template>
  <v-card
    v-if="calculator"
    class="white vetalfa-view"
    :max-width="_getMaxWidth()"
    flat
  >
    <div class="vetalfa-global-header" ref="screenHeader" v-if="!componentMode">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :breadcrumb="!!calculator ? calculator.name : null"
        :title="category ? category.portugueseName : null"
        hasHeaderOptions
      ></vetalfa-small-header>
      <v-row no-gutters justify="center">
        <vetalfa-drugs-header
          :name="calculator.name"
          :description="calculator.classes[0]"
          :displayCalculator="false"
          class="vetalfa-max-width my-4 px-2"
        >
        </vetalfa-drugs-header>
      </v-row>
    </div>
    <div ref="screenContent" style="height: 100%">
      <vetalfa-section-title
        class="text-left"
        :prop="'Preencha os campos abaixo'"
      >
        <v-row class="ma-0 pa-0 pa-2" align="center">
          <v-col cols="4" class="ma-0 pa-0">
            <v-text-field
              v-bind:id="`numeric-denominator`"
              type="text"
              hide-details
              inputmode="decimal"
              light
              v-model="denominator"
              dense
              color="primary"
              outlined
              placeholder=""
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <p class="ma-0 pa-0 rule-of-three-text">ESTÁ PARA</p>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <v-text-field
              v-bind:id="`numeric-firstNumerator`"
              type="text"
              hide-details
              inputmode="decimal"
              light
              v-model="firstNumerator"
              dense
              color="primary"
              outlined
              placeholder=""
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="ma-0 pa-0">
            <v-row
              class="ma-0 py-4 pa-0 vetalfa-card-title"
              justify="center"
              align="center"
            >
              ASSIM COMO
            </v-row>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <v-text-field
              v-bind:id="`numeric-secondNumerator`"
              type="text"
              hide-details
              inputmode="decimal"
              light
              v-model="secondNumerator"
              dense
              color="primary"
              outlined
              placeholder=""
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <p class="ma-0 pa-0 rule-of-three-text">ESTÁ PARA</p>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <v-row
              align="center"
              class="ma-0 pa-0 px-3 white--text primary rule-of-three-result"
            >
              <p class="ma-0 pa-0 vetalfa-text-overflow">{{ response }}</p>
            </v-row>
          </v-col>
        </v-row>
      </vetalfa-section-title>

      <vetalfa-general-tab
        v-if="!componentMode"
        :collapseAll="true"
        :sections="collapsedSections"
        :references="calculator.references"
      ></vetalfa-general-tab>
      <div style="height: 70px; background-color: white"></div>
    </div>
  </v-card>
</template>

<style scoped>
.rule-of-three-result {
  width: 100%;
  height: 40px;
  border-radius: 4px;
}
.rule-of-three-text {
  background-color: rgba(0, 0, 0, 0.1);
  color: black;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";

import calculatorLabels from "@/constants/labels/calculators.labels.js";
import labels from "@/constants/labels.js";
import BigNumber from "bignumber.js";
export default {
  name: "RuleOfThreeCalculator",
  computed: {
    ...mapGetters("drugs", ["category"]),
    ...mapGetters("calculators", ["calculator"]),
    collapsedSections() {
      let arr = [];
      this.calculator.sections.forEach((s) => {
        arr.push({ ...s, collapse: true });
      });
      return arr;
    },
  },
  props: {
    componentMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    ...mapActions("calculators", ["openCalculatorById"]),
    parseNumberField(e) {
      const id = e.srcElement.id.replace("numeric", "");
      const { value } = this._formatNumberField(e, this[id], 5);
      this[id] = value;
    },
    calculateResults() {
      if (!this.denominator || !this._strToNumber(this.denominator)) {
        this.response = "X";
        return;
      }
      this.response = new BigNumber(this._strToNumber(this.secondNumerator));
      this.response = new BigNumber(
        this._strToNumber(this.firstNumerator)
      ).times(this.response);
      this.response = this.response.dividedBy(
        new BigNumber(this._strToNumber(this.denominator))
      );
      this.response = this._formatNumber(this.response);
      if (["Infinity", "NaN"].includes(this.response)) {
        this.response = "X";
      }
    },
    setupVariables() {
      ["denominator", "firstNumerator", "secondNumerator"].forEach((n) => {
        let el = document.getElementById(`numeric-${n}`);
        el.value = 0;
        el.addEventListener("input", this.parseNumberField);
        el.addEventListener("focus", this.parseNumberField);
        el.addEventListener("blur", this.parseNumberField);
      });
    },
  },
  watch: {
    secondNumerator() {
      this.calculateResults();
    },
    firstNumerator() {
      this.calculateResults();
    },
    denominator() {
      this.calculateResults();
    },
  },
  data() {
    return {
      calculatorLabels,
      labels,
      response: "X",
      denominator: "",
      firstNumerator: "",
      secondNumerator: "",
    };
  },
  mounted() {
    if (this.calculator) {
      this.setupVariables();
      this._setupScreenSizes(this);
    }
  },
  created: async function () {
    if (
      !this.calculator ||
      this.calculator.id !== calculatorLabels.RULE_OF_THREE_ID
    ) {
      await this.openCalculatorById({
        id: calculatorLabels.RULE_OF_THREE_ID,
        redirect: false,
      });
      this.setupVariables();
      this._setupScreenSizes(this);
    }
  },
};
</script>
